import { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { homeFor, useAuth } from '../auth.jsx';
import AuthLayout from '../components/AuthLayout.jsx';
import Alert from '../components/ui/Alert.jsx';
import Field from '../components/Field.jsx';
import { checkEmail } from '../utils/validate.js';
import PasswordField from '../components/PasswordField.jsx';

export default function Login() {
  const auth = useAuth();
  const { user, login } = auth;
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={location.state?.from || homeFor(auth)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    const found = {};
    const emailProblem = checkEmail(email, { label: 'your email address' });
    if (emailProblem) found.email = emailProblem;
    if (!password) found.password = 'Enter your password.';
    setErrors(found);
    if (Object.keys(found).length) return;
    setBusy(true); setError('');
    try {
      const me = await login(email, password);
      navigate(location.state?.from || homeFor(me), { replace: true });
    } catch (err) {
      if (err.code === 'email_not_verified') {
        // Right password, email never confirmed: a code has been sent
        navigate('/verify-email', {
          state: { email: err.data.email, expires_at: err.data.expires_at, resend_after: err.data.resend_after },
        });
        return;
      }
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <AuthLayout onSubmit={submit}>
      <h1>Sign in</h1>
      {error && <Alert tone="danger">{error}</Alert>}
      <Field label="Email address" type="email" autoComplete="email" autoCapitalize="none" required value={email} error={errors.email}
        onChange={(e) => { setEmail(e.target.value); setErrors((x) => ({ ...x, email: undefined })); }} />
      <PasswordField label="Password" autoComplete="current-password" required value={password} error={errors.password}
        onChange={(e) => { setPassword(e.target.value); setErrors((x) => ({ ...x, password: undefined })); }} />
      {/* The address travels in page state, never in the web address */}
      <p className="forgot-link"><Link to="/forgot-password" state={{ email: email.trim() }}>Forgot your password?</Link></p>
      <button type="submit" className="btn btn-primary btn-block" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      <p className="auth-switch">New to SummitShield? <Link to="/register">Create an account</Link></p>
    </AuthLayout>
  );
}
